export default __webpack_public_path__ + "static/media/bfcSellerTransportation.322b8fb1.svg";